export default [
  'detalles',
  ...window.show_hotelbeds ? ['alojamiento'] : [],
  'extras',
  'datos-personales',
  'pago',
];
